<template>
  <b-modal
    v-model="showModal"
    title="Chi tiết lỗi"
    size="lg"
    ok-only
    ok-variant="primary"
    ok-title="Đóng"
    hide-backdrop
  >
    <div v-if="errorData">
      <b-row class="mb-2">
        <b-col md="4"><strong>Mã lỗi:</strong></b-col>
        <b-col md="8">{{ errorData.code || 'N/A' }}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col md="4"><strong>Thời gian:</strong></b-col>
        <b-col md="8">{{ formatDateTime(errorData.timestamp) }}</b-col>
      </b-row>
      <hr />
      <h6>Thông báo lỗi</h6>
      <b-alert show variant="danger">{{ errorData.message }}</b-alert>
      <h6 v-if="errorData.stackTrace">Stack Trace</h6>
      <pre
        v-if="errorData.stackTrace"
        class="bg-light p-3 rounded"
        style="max-height: 300px; overflow-y: auto;"
      ><code>{{ errorData.stackTrace }}</code></pre>
    </div>
  </b-modal>
</template>

<script>
import { CLIENT_DATE_TIME } from '@/utils/date';
const moment = require('moment');

export default {
  name: 'ErrorModal',
  data() {
    return {
      showModal: false,
      errorData: null,
    };
  },
  methods: {
    formatDateTime(date) {
      if (!date) return 'N/A';
      return moment(date).format(CLIENT_DATE_TIME);
    },
    show(errorData) {
      this.errorData = errorData;
      this.showModal = true;
    },
  },
};
</script>
